import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent, PrimeIcons } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import {
    ComboboxItemDtoOfLong,
    CatalogosGeneralesServiceProxy,
    PatientsServiceProxy,
    PatientForEditResponse,
    PatientGetForEditQuery,
    PatientCreateCommand,
    PatientGeneralUnitDto,
    PatientReferenceUnitDto,
    PatientUpdateCommand,
    PatientPathologicalDto,
    ComboboxItemDtoOfByte,
    PatientFaunaForListResponse,
    PatientFaunaGetListQuery,
    PatientFaunaCreateCommand,
    PatientFaunaDeleteCommand,
    PatientAllergieForListResponse,
    PatientAllergieGetListQuery,
    PatientAllergieCreateCommand,
    PatientAllergieDeleteCommand,
    PatientMedicalHistoryForListResponse,
    PatientMedicalHistoryGetListQuery,
    PatientMedicalHistoryDeleteCommand,
    PatientInterrogationSystemDto,
    PatientPhysicalExplorationUnitDto,
    PatientInitialStudyDto,
    IntegracionIMSSServiceProxy,
    BusquedaIMSSGetByIDEEQuery,
    ComboboxItemDtoOfTipoPacienteIMSSDto,
    BusquedaIMSSResultDto,
    BusquedaUrgenciasGetListQuery,
    ParametrosServiceProxy,
    ParametroGetByNameQuery,
    InstitucionAseguradaDto,
    BusquedaIMSSCrearPacienteCommand,
    PatientGinecoObstetricsDto
} from '../../../shared/service-proxies/service-proxies';
import { DateTimeService } from '../../../shared/services/datetime.service';
import { AppComponent } from '../../app.component';
import { BusquedaPacientesUrgenciasGridComponent } from '../../_components/consultas/pacientes/busquedapacientes-urgencias-grid.component';
import { ChangeLogService } from '../../_services/changelog.service';
import { EditPatientMedicalHistoryComponent } from './editpatientmedicalhistory.component';
import { AppConsts } from '../../../shared/AppConsts';
import * as moment from 'moment';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    templateUrl: './editpatient.component.html',
    styleUrls: ['../../../assets/css-custom/p-datatable-general.scss'],
    providers: [AppComponent]
})
export class EditPatientComponent extends AppComponentBase implements OnInit {

    @ViewChild('dtFauna', { static: false }) tableFauna;
    @ViewChild('dtAllergie', { static: false }) tableAllergie;
    @ViewChild('dtMedicalHistory', { static: false }) tableMedicalHistory;
    @ViewChild('name', { static: false }) inputFocus: ElementRef;

    form: FormGroup;

    id?: number = null;
    model: PatientForEditResponse = new PatientForEditResponse();

    patientTypeImssList: ComboboxItemDtoOfTipoPacienteIMSSDto[] = [];
    sexList: ComboboxItemDtoOfLong[] = [];
    institutionList: ComboboxItemDtoOfLong[] = [];
    institutionsValidateList: InstitucionAseguradaDto[] = [];
    delegationList: ComboboxItemDtoOfLong[] = [];
    umfList: ComboboxItemDtoOfLong[] = [];
    patientQualityList: ComboboxItemDtoOfLong[] = [];
    maritalStatusList: ComboboxItemDtoOfLong[] = [];
    educationLevelList: ComboboxItemDtoOfLong[] = [];
    religionList: ComboboxItemDtoOfLong[] = [];
    occupationList: ComboboxItemDtoOfLong[] = [];
    countryList: ComboboxItemDtoOfLong[] = [];
    stateList: ComboboxItemDtoOfLong[] = [];
    municipalityList: ComboboxItemDtoOfLong[] = [];

    birthStateList: ComboboxItemDtoOfLong[] = [];
    delegationImssRequestList: ComboboxItemDtoOfLong[] = [];
    umfRequestList: ComboboxItemDtoOfLong[] = [];
    medicalCareUnitList: ComboboxItemDtoOfLong[] = [];
    hospitalServiceList: ComboboxItemDtoOfLong[] = [];
    patientOriginList: ComboboxItemDtoOfLong[] = [];
    originList: ComboboxItemDtoOfLong[] = [];
    attentionTypeList: ComboboxItemDtoOfLong[] = [];
    shiftList: ComboboxItemDtoOfLong[] = [];
    agreementTypeList: ComboboxItemDtoOfLong[] = [];

    referenceUnitList: PatientReferenceUnitDto[] = [];

    relationshipList: ComboboxItemDtoOfLong[] = [];

    bloodTypeList: ComboboxItemDtoOfLong[] = [];
    rhFactorList: ComboboxItemDtoOfLong[] = [];
    housingTypeList: ComboboxItemDtoOfLong[] = [];
    etiologyList: ComboboxItemDtoOfLong[] = [];
    vaccinationScheduleList: ComboboxItemDtoOfByte[] = [];
    alcoholismLevelList: ComboboxItemDtoOfByte[] = [];
    faunaList: ComboboxItemDtoOfLong[] = [];
    faunaTypeList: ComboboxItemDtoOfLong[] = [];
    familiarPlanningMethodsList: ComboboxItemDtoOfLong[] = [];
    cicloMenstrualList: ComboboxItemDtoOfLong[] = [];
    colsFauna: any[];
    dataFauna: PatientFaunaForListResponse[] = [];
    queryFauna: PatientFaunaGetListQuery = new PatientFaunaGetListQuery();
    pagedTableSummaryFauna: PagedTableSummary = new PagedTableSummary();
    allergieList: ComboboxItemDtoOfLong[] = [];
    colsAllergie: any[];
    dataAllergie: PatientAllergieForListResponse[] = [];
    queryAllergie: PatientAllergieGetListQuery = new PatientAllergieGetListQuery();
    pagedTableSummaryAllergie: PagedTableSummary = new PagedTableSummary();

    colsMedicalHistory: any[];
    dataMedicalHistory: PatientMedicalHistoryForListResponse[] = [];
    queryMedicalHistory: PatientMedicalHistoryGetListQuery = new PatientMedicalHistoryGetListQuery();
    pagedTableSummaryMedicalHistory: PagedTableSummary = new PagedTableSummary();

    editFieldsPermission = false;
    isIdeeButton = false;
    institutionImssId = 0;
    maleId = 0;
    femaleId = 0;

    codigoInstitucionIMSS: string;
    esIMSS = false;
    esDerechohabiente = false;

    PrimeIcons = PrimeIcons;

    esModal = false;
    lockScreen = false;
    // app: AppComponent;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private patientsService: PatientsServiceProxy,
        private catalogosGeneralesService: CatalogosGeneralesServiceProxy,
        private integracionIMSSService: IntegracionIMSSServiceProxy,
        private parametrosService: ParametrosServiceProxy,
        private dateTimeService: DateTimeService,
        private changeLogService: ChangeLogService,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig,
        private app: AppComponent,
        private sanitizer: DomSanitizer
    ) {
        super(injector);
        // this.app = injector.get(AppComponent);
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    ngOnInit() {
        const self = this;

        if (self.modalConfig && self.modalConfig.data) {
            self.esModal = true;
            self.id = self.modalConfig.data.id;
        } else {

            if (self.activatedRoute.snapshot.url.length > 1 && self.activatedRoute.snapshot.url[1].path === 'edit') {
                self.id = self.activatedRoute.snapshot.params['id'] ? Number(self.activatedRoute.snapshot.params['id']) : null;
            }
        }

        self.editFieldsPermission = self.permission.isGranted('Catalogos.Patients.EditFields');

        self.prepareForm();

        self.getCicloMenstrualCombo();
        self.getParametroIMSS();
        self.getForEdit(self.id);
    }

    getCicloMenstrualCombo(): void {
        const self = this;

        self.cicloMenstrualList = [];
        self.cicloMenstrualList.push(new ComboboxItemDtoOfLong({ value: 1, label: 'REGULAR' }));
        self.cicloMenstrualList.push(new ComboboxItemDtoOfLong({ value: 2, label: 'IRREGULAR' }));
    }

    getParametroIMSS(): void {
        const self = this;

        const req = new ParametroGetByNameQuery();
        req.nombreParametro = 'CODIGO_INSTITUCION_IMSS';
        req.buscarEnHost = true;

        self.parametrosService.getParametro(req)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                if (data != null) {
                    self.codigoInstitucionIMSS = data.valor;
                }
            });
    }

    changeCountry(): void {
        const self = this;

        if (self.f.country.value) {
            self.getStates(self.f.country.value);
        } else {
            self.stateList = [];
        }
    }

    getStates(countryId: number): void {
        const self = this;

        self.lock();

        self.catalogosGeneralesService.getEstadosForCombobox(countryId)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.stateList = data;

                if (self.model.state) {
                    self.changeState();
                }
            });
    }

    changeState(): void {
        const self = this;

        if (self.f.state.value) {
            self.getMunicipios(self.f.state.value);
        } else {
            self.municipalityList = [];
        }
    }

    getMunicipios(estadoId: number): void {
        const self = this;

        self.lock();

        self.catalogosGeneralesService.getMunicipiosForCombobox(estadoId)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.municipalityList = data;
            });
    }

    changeBirthCountry(): void {
        const self = this;

        if (self.f.birthCountry.value) {
            self.getBirthStates(self.f.birthCountry.value);
        } else {
            self.birthStateList = [];
        }
    }

    getBirthStates(countryId: number): void {
        const self = this;

        self.lock();

        self.catalogosGeneralesService.getEstadosForCombobox(countryId)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.birthStateList = data;
            });
    }

    changeCountryReference(reference: PatientReferenceUnitDto): void {
        const self = this;

        if (reference.country) {
            self.getStatesReference(reference);
        } else {
            reference.stateCombo = [];
        }
    }

    getStatesReference(reference: PatientReferenceUnitDto): void {
        const self = this;

        self.lock();

        self.catalogosGeneralesService.getEstadosForCombobox(reference.country)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                reference.stateCombo = data;

                if (reference.state) {
                    self.changeStateReference(reference);
                }
            });
    }

    changeStateReference(reference: PatientReferenceUnitDto): void {
        const self = this;

        if (reference.state) {
            self.getMunicipiosReference(reference);
        } else {
            reference.municipalityCombo = [];
        }
    }

    getMunicipiosReference(reference: PatientReferenceUnitDto): void {
        const self = this;

        self.lock();

        self.catalogosGeneralesService.getMunicipiosForCombobox(reference.state)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                reference.municipalityCombo = data;
            });
    }

    getForEdit(id: number): void {
        const self = this;
        const query = new PatientGetForEditQuery();

        query.id = self.id;
        self.lock();

        self.patientsService.getPatientForEdit(query)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.model = data;

                // Si hay una entrada en el almacenamiento interno del navegador, quiere decir que esta pantalla se está cargando
                // desde la búsqueda de pacientes por urgencias y por IMSS y que ese paciente no está registrado localmente..
                if (!self.model.id) {
                    const ex = self.browserStorageService.get(AppConsts.localStoragePatientKey);
                    if (ex) {
                        const pex: BusquedaIMSSResultDto = ex as BusquedaIMSSResultDto;

                        self.model.idee = pex.idee;
                        self.model.name = pex.nombre;
                        self.model.firstName = pex.apellidoPaterno;
                        self.model.lastName = pex.apellidoMaterno;
                        self.model.curp = pex.curp;
                        self.model.nss = pex.nss;
                        self.model.medicalAttache = pex.agregadoMedico;
                        self.model.birthDate = moment(pex.fechaNacimiento).utc();
                        self.model.sex = pex.sexo === 'Masculino' ? 1 : 2;
                        self.model.patientTypeImss = 1; // Se asume que es derechohabiente
                        self.model.postalCode = parseInt(pex.codigoPostal, 10);
                        self.model.street = pex.calle;
                        self.model.suburb = pex.colonia;

                        // Inferir el hospital desde la clave presupuestal
                        if (pex.clavePresupuestal) {
                            self.getUMFRequestByClavePresupuestal(pex.clavePresupuestal);
                        }

                        // Deshabilitar los campos llenados previamente desde la info del IMSS
                        self.f.name.disable();
                        self.f.firstName.disable();
                        self.f.lastName.disable();
                        self.f.curp.disable();
                        self.f.nss.disable();
                        self.f.medicalAttache.disable();
                        self.f.birthDate.disable();
                        self.f.sex.disable();
                    }
                }

                // Si hay algo en localstorage, entonces debe ser eliminado
                self.browserStorageService.remove(AppConsts.localStoragePatientKey);

                // Antes de bloquear campos, hay que hacer algunas validaciones
                // Si ya hay IDEE y es Derechohabiente, entonces esta bandera debe ser "false"
                if (self.model.idee && self.model.patientTypeImss === 1) {
                    self.editFieldsPermission = false;
                }

                self.blockFields();

                const optInstitutionImss = data.institutionCombo.find(m => m.value.codigoInstitucion === 'IMSS');

                if (optInstitutionImss) {
                    self.institutionImssId = optInstitutionImss.value.id;
                }

                self.patientTypeImssList = data.patientTypeImssCombo;

                let optSex = data.sexCombo.find(m => m.value.claveSexo === 'H');

                if (optSex) {
                    self.maleId = optSex.value.id;
                }

                optSex = data.sexCombo.find(m => m.value.claveSexo === 'M');

                if (optSex) {
                    self.femaleId = optSex.value.id;
                }

                data.sexCombo.forEach(opt => {
                    self.sexList.push(new ComboboxItemDtoOfLong({ value: opt.value.id, label: opt.label }));
                });

                self.delegationList = data.delegationCombo;
                // self.umfList = data.umfCombo;
                self.patientQualityList = data.patientQualityCombo;
                self.maritalStatusList = data.maritalStatusCombo;
                self.educationLevelList = data.educationLevelCombo;
                self.religionList = data.religionCombo;
                self.occupationList = data.occupationCombo;
                self.countryList = data.countryCombo;
                self.stateList = data.stateCombo;
                self.municipalityList = data.municipalityCombo;

                data.institutionCombo.forEach(opt => {
                    self.institutionList.push(new ComboboxItemDtoOfLong({ value: opt.value.id, label: opt.label }));
                    self.institutionsValidateList.push(opt.value);
                });

                self.birthStateList = data.birthStateCombo;
                // self.hospitalServiceList = data.hospitalServiceCombo;
                self.patientOriginList = data.patientOriginCombo;
                self.originList = data.originCombo;
                self.attentionTypeList = data.attentionTypeCombo;
                self.shiftList = data.shiftCombo;
                self.agreementTypeList = data.agreementTypeCombo;

                self.relationshipList = data.relationshipCombo;

                self.bloodTypeList = data.bloodTypeCombo;
                self.rhFactorList = data.rhFactorCombo;
                self.etiologyList = data.etiologyCombo;
                self.vaccinationScheduleList = data.vaccinationScheduleCombo;
                self.alcoholismLevelList = data.alcoholismLevelCombo;
                self.housingTypeList = data.housingTypeCombo;
                self.faunaTypeList = data.faunaTypeCombo;
                self.allergieList = data.allergieCombo;
                self.familiarPlanningMethodsList = data.familiarPlanningMethodsCombo;

                self.f.idee.setValue(self.model.idee);

                if (self.model.patientTypeImss) {
                    const optPatientTypeImss = self.patientTypeImssList.find(m => m.value.id === self.model.patientTypeImss);
                    self.f.patientTypeImss.setValue(optPatientTypeImss ? optPatientTypeImss.value : null);
                }

                self.f.institution.setValue(self.model.institution);
                self.f.delegation.setValue(self.model.delegation);
                self.changeDelegation();

                self.f.umf.setValue(self.model.umf);
                self.f.sex.setValue(self.model.sex);
                self.f.patientQuality.setValue(self.model.patientQuality);
                self.f.maritalStatus.setValue(self.model.maritalStatus);
                self.f.educationLevel.setValue(self.model.educationLevel);
                self.f.religion.setValue(self.model.religion);
                self.f.occupation.setValue(self.model.occupation);
                self.f.country.setValue(self.model.country);
                self.f.state.setValue(self.model.state);
                self.f.municipality.setValue(self.model.municipality);
                self.f.name.setValue(self.model.name);
                self.f.firstName.setValue(self.model.firstName);
                self.f.lastName.setValue(self.model.lastName);
                self.f.nss.setValue(self.model.nss);
                self.f.medicalAttache.setValue(self.model.medicalAttache);
                self.f.curp.setValue(self.model.curp);

                if (self.model.birthDate) {
                    self.f.birthDate.setValue(self.dateTimeService.getDateToAssignInFormControl(self.model.birthDate));
                }

                self.f.yearsStudy.setValue(self.model.yearsStudy);
                self.f.street.setValue(self.model.street);
                self.f.internalNumber.setValue(self.model.internalNumber);
                self.f.externalNumber.setValue(self.model.externalNumber);
                self.f.postalCode.setValue(self.model.postalCode);
                self.f.phone.setValue(self.model.phone);
                self.f.cellPhone.setValue(self.model.cellPhone);
                self.f.betweenStreets.setValue(self.model.betweenStreets);
                self.f.pointsReference.setValue(self.model.pointsReference);
                self.f.suburb.setValue(self.model.suburb);
                self.f.isActive.setValue(self.model.isActive);

                self.f.birthCountry.setValue(self.model.birthCountry);
                self.f.birthState.setValue(self.model.birthState);
                self.f.rfc.setValue(self.model.rfc);

                if (self.model.deathDate) {
                    self.f.deathDate.setValue(self.dateTimeService.getDateToAssignInFormControl(self.model.deathDate));
                }

                if (self.model.generalUnit) {

                    self.f.delegationImssRequest.setValue(self.model.generalUnit.delegationImssRequest);
                    self.changeDelegationRequest();

                    self.f.medicalCareUnit.setValue(self.model.generalUnit.medicalCareUnit);
                    self.changeUmfRequest();

                    self.f.hospitalService.setValue(self.model.generalUnit.hospitalService);
                    self.f.patientOrigin.setValue(self.model.generalUnit.patientOrigin);
                    self.f.origin.setValue(self.model.generalUnit.origin);

                    self.f.attentionType.setValue(self.model.generalUnit.attentionType);
                    self.f.attentionPlace.setValue(self.model.generalUnit.attentionPlace);
                    self.f.shift.setValue(self.model.generalUnit.shift);
                    self.f.doctorOffice.setValue(self.model.generalUnit.doctorOffice);

                    if (self.model.generalUnit.validUntil) {
                        self.f.validUntil.setValue(self.dateTimeService.getDateToAssignInFormControl(self.model.generalUnit.validUntil));
                    }

                    self.f.membershipAggregate.setValue(self.model.generalUnit.membershipAggregate);
                    self.f.agreementType.setValue(self.model.generalUnit.agreementType);
                    self.f.observations.setValue(self.model.generalUnit.observations);
                }

                self.referenceUnitList = self.model.referenceUnitList;

                if (self.model.pathological) {
                    self.f.bloodType.setValue(self.model.pathological.bloodType);
                    self.f.rhFactor.setValue(self.model.pathological.rhFactor);

                    self.f.etiology.setValue(self.model.pathological.etiology);
                    self.f.housingType.setValue(self.model.pathological.housingType);
                    self.f.isVHB.setValue(self.model.pathological.isVHB);
                    self.f.isVHC.setValue(self.model.pathological.isVHC);
                    self.f.isVIH.setValue(self.model.pathological.isVIH);
                    self.f.albumina.setValue(self.model.pathological.albumina);
                    self.f.basalBloodGlucose.setValue(self.model.pathological.basalBloodGlucose);
                    self.f.hbA1c.setValue(self.model.pathological.hbA1c);
                    self.f.isDiabetes.setValue(self.model.pathological.isDiabetes);
                    self.f.cholesterol.setValue(self.model.pathological.cholesterol);
                    self.f.cholesterolHDL.setValue(self.model.pathological.cholesterolHDL);
                    self.f.cholesterolLDL.setValue(self.model.pathological.cholesterolLDL);
                    self.f.triglycerides.setValue(self.model.pathological.triglycerides);

                    if (self.model.pathological.sanefroDate) {
                        self.f.sanefroDate.setValue(self.dateTimeService.getDateToAssignInFormControl(self.model.pathological.sanefroDate));
                    }

                    self.f.vaccinationSchedule.setValue(self.model.pathological.vaccinationSchedule);
                    self.f.vaccinationScheduleMissing.setValue(self.model.pathological.vaccinationScheduleMissing);
                    self.f.foodPredominance.setValue(self.model.pathological.foodPredominance);
                    self.f.isSmoking.setValue(self.model.pathological.isSmoking);
                    self.f.smokingYears.setValue(self.model.pathological.smokingYears);
                    self.f.smokingMonths.setValue(self.model.pathological.smokingMonths);
                    self.f.cigars.setValue(self.model.pathological.cigars);
                    self.f.isAlcoholism.setValue(self.model.pathological.isAlcoholism);
                    self.f.alcoholismLevel.setValue(self.model.pathological.alcoholismLevel);
                    self.f.others.setValue(self.model.pathological.others);
                    self.f.isBasicServices.setValue(self.model.pathological.isBasicServices);
                    self.f.isWater.setValue(self.model.pathological.isWater);
                    self.f.isElectricity.setValue(self.model.pathological.isElectricity);
                    self.f.isSewerSystem.setValue(self.model.pathological.isSewerSystem);
                    self.f.ivsa.setValue(self.model.pathological.ivsa);
                    self.f.sexualPartners.setValue(self.model.pathological.sexualPartners);
                }

                if (self.model.interrogationSystem) {
                    self.f.isRespiratory.setValue(self.model.interrogationSystem.isRespiratory);
                    self.f.isCardiovascular.setValue(self.model.interrogationSystem.isCardiovascular);
                    self.f.isDigestive.setValue(self.model.interrogationSystem.isDigestive);
                    self.f.isGenitourinary.setValue(self.model.interrogationSystem.isGenitourinary);
                    self.f.isMusculoskeletal.setValue(self.model.interrogationSystem.isMusculoskeletal);
                    self.f.isEndocrine.setValue(self.model.interrogationSystem.isEndocrine);
                    self.f.isNeuropsychiatric.setValue(self.model.interrogationSystem.isNeuropsychiatric);
                    self.f.hematopoietic.setValue(self.model.interrogationSystem.hematopoietic);
                    self.f.skinIntegument.setValue(self.model.interrogationSystem.skinIntegument);
                    self.f.respiratoryComments.setValue(self.model.interrogationSystem.respiratoryComments);
                    self.f.cardiovascularComments.setValue(self.model.interrogationSystem.cardiovascularComments);
                    self.f.digestiveComments.setValue(self.model.interrogationSystem.digestiveComments);
                    self.f.genitourinaryComments.setValue(self.model.interrogationSystem.genitourinaryComments);
                    self.f.musculoskeletaComments.setValue(self.model.interrogationSystem.musculoskeletaComments);
                    self.f.endocrineComments.setValue(self.model.interrogationSystem.endocrineComments);
                    self.f.neuropsychiatricComments.setValue(self.model.interrogationSystem.neuropsychiatricComments);
                }

                if (self.model.physicalExplorationUnit) {
                    self.f.physicalExplorationUnitImc.setValue(self.model.physicalExplorationUnit.imc);
                    self.f.physicalExplorationUnitTa.setValue(self.model.physicalExplorationUnit.ta);
                    self.f.physicalExplorationUnitHeartRate.setValue(self.model.physicalExplorationUnit.heartRate);
                    self.f.physicalExplorationUnitBreathingFrequency.setValue(self.model.physicalExplorationUnit.breathingFrequency);
                    self.f.physicalExplorationUnitTemperature.setValue(self.model.physicalExplorationUnit.temperature);
                    self.f.physicalExplorationUnitSatO2.setValue(self.model.physicalExplorationUnit.satO2);
                    self.f.physicalExplorationUnitActualWeight.setValue(self.model.physicalExplorationUnit.actualWeight);
                    self.f.physicalExplorationUnitDryWeight.setValue(self.model.physicalExplorationUnit.dryWeight);
                    self.f.physicalExplorationUnitObservations.setValue(self.model.physicalExplorationUnit.observations);
                }

                if (self.model.initialStudy) {
                    self.f.initialStudyLeukocytes.setValue(self.model.initialStudy.leukocytes);
                    self.f.initialStudyErythrocytes.setValue(self.model.initialStudy.erythrocytes);
                    self.f.initialStudyHematrocitos.setValue(self.model.initialStudy.hematrocitos);
                    self.f.initialStudyHemoglobin.setValue(self.model.initialStudy.hemoglobin);
                    self.f.initialStudyVolCorMiddle.setValue(self.model.initialStudy.volCorMiddle);
                    self.f.initialStudyHcm.setValue(self.model.initialStudy.hcm);
                    self.f.initialStudyPlatelets.setValue(self.model.initialStudy.platelets);
                    self.f.initialStudyVolPlatMiddle.setValue(self.model.initialStudy.volPlatMiddle);
                    self.f.initialStudyNeutrophils.setValue(self.model.initialStudy.neutrophils);
                    self.f.initialStudyLymphocytes.setValue(self.model.initialStudy.lymphocytes);
                    self.f.initialStudyMonocytes.setValue(self.model.initialStudy.monocytes);
                    self.f.initialStudyEosinophils.setValue(self.model.initialStudy.eosinophils);
                    self.f.initialStudyBasophils.setValue(self.model.initialStudy.basophils);
                    self.f.initialStudyUrea.setValue(self.model.initialStudy.urea);
                    self.f.initialStudyCreatinine.setValue(self.model.initialStudy.creatinine);
                    self.f.initialStudyGlucose.setValue(self.model.initialStudy.glucose);
                    self.f.initialStudyUricAC.setValue(self.model.initialStudy.uricAC);
                    self.f.initialStudyTfg.setValue(self.model.initialStudy.tfg);
                    self.f.initialStudyAst.setValue(self.model.initialStudy.ast);
                    self.f.initialStudyAlt.setValue(self.model.initialStudy.alt);
                    self.f.initialStudyAlbumin.setValue(self.model.initialStudy.albumin);
                    self.f.initialStudyTp.setValue(self.model.initialStudy.tp);
                    self.f.initialStudyTpt.setValue(self.model.initialStudy.tpt);
                    self.f.initialStudyInr.setValue(self.model.initialStudy.inr);
                    self.f.initialStudyRadiographyComments.setValue(self.model.initialStudy.radiographyComments);
                    self.f.initialStudyElectrocardiogramComments.setValue(self.model.initialStudy.electrocardiogramComments);
                }

                if (self.model.ginecoObstetrics) {
                    self.f.familiarPlanningMethod.setValue(self.model.ginecoObstetrics.metodoPlanificacionFamiliarId);
                    self.f.menarca.setValue(self.model.ginecoObstetrics.menarca);
                    self.f.ciclo.setValue(self.model.ginecoObstetrics.ciclo);
                    self.f.menstrualIrregularity.setValue(self.model.ginecoObstetrics.alteracionMenstrual);
                    self.f.lastPapilomaDate.setValue(self.dateTimeService.getDateToAssignInFormControl(
                        self.model.ginecoObstetrics.fechaUltimoPapiloma));
                    self.f.result.setValue(self.model.ginecoObstetrics.resultado);
                    self.f.pregnancies.setValue(self.model.ginecoObstetrics.gestas);
                    self.f.births.setValue(self.model.ginecoObstetrics.partos);
                    self.f.cSections.setValue(self.model.ginecoObstetrics.cesareas);
                    self.f.abortions.setValue(self.model.ginecoObstetrics.abortos);
                }

                self.changeInstitution();
                self.setEsDerechohabiente();

                if (self.model.id) {
                    self.getFaunaList();
                    self.getAllergieList();
                    self.getMedicalHistoryList();
                }

                // self.changeCountry();
            });
    }

    save(): void {
        const self = this;

        // Se deben revisar los campos CURP, Pais, Estado, Grupo sanguíneo, Factor RH,
        // Ocupación, Religión, Escolaridad, Estado civil, Domicilio, Telefono, UMF,
        // Primer apellido contacto, Nombre contacto, Telefono contacto, PArentesco contacto,
        // OOAD, UMF Sol, Servicio SOl
        // Si falta alguno de estos campos, se debe informar al usuario y continuar con el guardado de los datos
        const campos = [];

        if (!self.f.curp.value) {
            campos.push(self.l('Catalogos.Patients.General1.CURP.Form'));
        }
        if (!self.f.country.value) {
            campos.push(self.l('Catalogos.Patients.General1.Country.Form'));
        }
        if (!self.f.state.value) {
            campos.push(self.l('Catalogos.Patients.General1.State.Form'));
        }
        if (!self.f.bloodType.value) {
            campos.push(self.l('Catalogos.Patients.Pathological.BloodType.Form'));
        }
        if (!self.f.rhFactor.value) {
            campos.push(self.l('Catalogos.Patients.Pathological.RHFactor.Form'));
        }
        if (!self.f.occupation.value) {
            campos.push(self.l('Catalogos.Patients.General1.Occupation.Form'));
        }
        if (!self.f.religion.value) {
            campos.push(self.l('Catalogos.Patients.General1.Religion.Form'));
        }
        if (!self.f.educationLevel.value) {
            campos.push(self.l('Catalogos.Patients.General1.EducationLevel.Form'));
        }
        if (!self.f.maritalStatus.value) {
            campos.push(self.l('Catalogos.Patients.General1.MaritalStatus.Form'));
        }
        if (!self.f.street.value) {
            campos.push(self.l('Catalogos.Patients.General1.Street.Form'));
        }
        if (!self.f.phone.value) {
            campos.push(self.l('Catalogos.Patients.General1.Phone.Form'));
        }
        if (!self.f.cellPhone.value) {
            campos.push(self.l('Catalogos.Patients.General1.CellPhone.Form'));
        }
        if (!self.f.umf.value) {
            campos.push(self.l('Catalogos.Patients.General1.UMF.Form'));
        }


        const cfLegend = self.l('Catalogos.Patients.References.FamilyContact.Form');
        const contactoF = self.referenceUnitList.find(m => m.reference === 1);

        if (!contactoF || !contactoF.firstName) {
            campos.push(self.l('Catalogos.Patients.References.FirstName.Form') + ' ' + cfLegend);
        }
        if (!contactoF || !contactoF.name) {
            campos.push(self.l('Catalogos.Patients.References.Name.Form') + ' ' + cfLegend);
        }
        if (!contactoF || !contactoF.phone) {
            campos.push(self.l('Catalogos.Patients.References.Phone.Form') + ' ' + cfLegend);
        }
        if (!contactoF || !contactoF.relationship) {
            campos.push(self.l('Catalogos.Patients.References.Relationship.Form') + ' ' + cfLegend);
        }

        if (!self.f.delegationImssRequest.value) {
            campos.push(self.l('Catalogos.Patients.General2.DelegationImssRequest.Form'));
        }
        if (!self.f.medicalCareUnit.value) {
            campos.push(self.l('Catalogos.Patients.General2.MedicalCareUnit.Form'));
        }
        if (!self.f.hospitalService.value) {
            campos.push(self.l('Catalogos.Patients.General2.HospitalService.Form'));
        }

        if (campos.length > 0) {
            const camposStr = '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
                + campos.join('<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;') + '<br/>';

            self.alertService.warning(self.l('Catalogs.Patients.MissingData.Information', camposStr), () => {
                self.doSave();
            });
        } else {
            self.doSave();
        }
    }

    doSave(): void {
        const self = this;

        if (self.id) {
            const cmd = new PatientUpdateCommand();

            cmd.id = self.model.id;
            cmd.idee = self.f.idee.value;
            cmd.patientTypeImss = self.f.patientTypeImss.value ? self.f.patientTypeImss.value.id : null;
            cmd.institution = self.f.institution.value;
            cmd.delegation = self.f.delegation.value;
            cmd.umf = self.f.umf.value;
            cmd.sex = self.f.sex.value;
            cmd.patientQuality = self.f.patientQuality.value;
            cmd.maritalStatus = self.f.maritalStatus.value;
            cmd.educationLevel = self.f.educationLevel.value;
            cmd.religion = self.f.religion.value;
            cmd.occupation = self.f.occupation.value;
            cmd.municipality = self.f.municipality.value;
            cmd.name = self.f.name.value;
            cmd.firstName = self.f.firstName.value;
            cmd.lastName = self.f.lastName.value;
            cmd.nss = self.f.nss.value;
            cmd.medicalAttache = self.f.medicalAttache.value;
            cmd.curp = self.f.curp.value;
            cmd.birthDate = self.f.birthDate.value;
            cmd.yearsStudy = self.f.yearsStudy.value;
            cmd.street = self.f.street.value;
            cmd.internalNumber = self.f.internalNumber.value;
            cmd.externalNumber = self.f.externalNumber.value;
            cmd.postalCode = self.f.postalCode.value;
            cmd.phone = self.f.phone.value;
            cmd.cellPhone = self.f.cellPhone.value;
            cmd.betweenStreets = self.f.betweenStreets.value;
            cmd.pointsReference = self.f.pointsReference.value;
            cmd.suburb = self.f.suburb.value;
            cmd.isActive = self.f.isActive.value;

            cmd.birthState = self.f.birthState.value;
            cmd.rfc = self.f.rfc.value;
            cmd.deathDate = self.f.deathDate.value;

            cmd.generalUnit = new PatientGeneralUnitDto();
            cmd.generalUnit.id = self.model.generalUnit ? self.model.generalUnit.id : null;
            cmd.generalUnit.delegationImssRequest = self.f.delegationImssRequest.value;
            cmd.generalUnit.medicalCareUnit = self.f.medicalCareUnit.value;
            cmd.generalUnit.hospitalService = self.f.hospitalService.value;
            cmd.generalUnit.patientOrigin = self.f.patientOrigin.value;
            cmd.generalUnit.origin = self.f.origin.value;
            cmd.generalUnit.attentionType = self.f.attentionType.value;
            cmd.generalUnit.attentionPlace = self.f.attentionPlace.value;
            cmd.generalUnit.shift = self.f.shift.value;
            cmd.generalUnit.doctorOffice = self.f.doctorOffice.value;
            cmd.generalUnit.validUntil = self.f.validUntil.value;
            cmd.generalUnit.membershipAggregate = self.f.membershipAggregate.value;
            cmd.generalUnit.agreementType = self.f.agreementType.value;
            cmd.generalUnit.observations = self.f.observations.value;

            cmd.referenceUnitList = self.model.referenceUnitList.filter(m => m.isChecked);

            cmd.pathological = new PatientPathologicalDto();
            cmd.pathological.id = self.model.pathological ? self.model.pathological.id : null;
            cmd.pathological.bloodType = self.f.bloodType.value;
            cmd.pathological.rhFactor = self.f.rhFactor.value;
            cmd.pathological.etiology = self.f.etiology.value;
            cmd.pathological.housingType = self.f.housingType.value;
            cmd.pathological.isVHB = self.f.isVHB.value;
            cmd.pathological.isVHC = self.f.isVHC.value;
            cmd.pathological.isVIH = self.f.isVIH.value;
            cmd.pathological.albumina = self.f.albumina.value;
            cmd.pathological.basalBloodGlucose = self.f.basalBloodGlucose.value;
            cmd.pathological.hbA1c = self.f.hbA1c.value;
            cmd.pathological.isDiabetes = self.f.isDiabetes.value;
            cmd.pathological.cholesterol = self.f.cholesterol.value;
            cmd.pathological.cholesterolHDL = self.f.cholesterolHDL.value;
            cmd.pathological.cholesterolLDL = self.f.cholesterolLDL.value;
            cmd.pathological.triglycerides = self.f.triglycerides.value;
            cmd.pathological.sanefroDate = self.f.sanefroDate.value;
            cmd.pathological.vaccinationSchedule = self.f.vaccinationSchedule.value ? self.f.vaccinationSchedule.value : false;
            cmd.pathological.vaccinationScheduleMissing = self.f.vaccinationScheduleMissing.value;
            cmd.pathological.foodPredominance = self.f.foodPredominance.value;
            cmd.pathological.isSmoking = self.f.isSmoking.value;
            cmd.pathological.smokingYears = self.f.smokingYears.value;
            cmd.pathological.smokingMonths = self.f.smokingMonths.value;
            cmd.pathological.cigars = self.f.cigars.value;
            cmd.pathological.isAlcoholism = self.f.isAlcoholism.value;
            cmd.pathological.alcoholismLevel = self.f.alcoholismLevel.value;
            cmd.pathological.others = self.f.others.value;
            cmd.pathological.isBasicServices = self.f.isBasicServices.value;
            cmd.pathological.isWater = self.f.isWater.value;
            cmd.pathological.isElectricity = self.f.isElectricity.value;
            cmd.pathological.isSewerSystem = self.f.isSewerSystem.value;
            cmd.pathological.ivsa = self.f.ivsa.value;
            cmd.pathological.sexualPartners = self.f.sexualPartners.value;

            cmd.interrogationSystem = new PatientInterrogationSystemDto();
            cmd.interrogationSystem.id = self.model.interrogationSystem ? self.model.interrogationSystem.id : null;
            cmd.interrogationSystem.isRespiratory = self.f.isRespiratory.value;
            cmd.interrogationSystem.isCardiovascular = self.f.isCardiovascular.value;
            cmd.interrogationSystem.isDigestive = self.f.isDigestive.value;
            cmd.interrogationSystem.isGenitourinary = self.f.isGenitourinary.value;
            cmd.interrogationSystem.isMusculoskeletal = self.f.isMusculoskeletal.value;
            cmd.interrogationSystem.isEndocrine = self.f.isEndocrine.value;
            cmd.interrogationSystem.isNeuropsychiatric = self.f.isNeuropsychiatric.value;
            cmd.interrogationSystem.hematopoietic = self.f.hematopoietic.value;
            cmd.interrogationSystem.skinIntegument = self.f.skinIntegument.value;
            cmd.interrogationSystem.respiratoryComments = self.f.respiratoryComments.value;
            cmd.interrogationSystem.cardiovascularComments = self.f.cardiovascularComments.value;
            cmd.interrogationSystem.digestiveComments = self.f.digestiveComments.value;
            cmd.interrogationSystem.genitourinaryComments = self.f.genitourinaryComments.value;
            cmd.interrogationSystem.musculoskeletaComments = self.f.musculoskeletaComments.value;
            cmd.interrogationSystem.endocrineComments = self.f.endocrineComments.value;
            cmd.interrogationSystem.neuropsychiatricComments = self.f.neuropsychiatricComments.value;

            cmd.physicalExplorationUnit = new PatientPhysicalExplorationUnitDto();
            cmd.physicalExplorationUnit.id = self.model.physicalExplorationUnit ? self.model.physicalExplorationUnit.id : null;
            cmd.physicalExplorationUnit.imc = self.f.physicalExplorationUnitImc.value;
            cmd.physicalExplorationUnit.ta = self.f.physicalExplorationUnitTa.value;
            cmd.physicalExplorationUnit.heartRate = self.f.physicalExplorationUnitHeartRate.value;
            cmd.physicalExplorationUnit.breathingFrequency = self.f.physicalExplorationUnitBreathingFrequency.value;
            cmd.physicalExplorationUnit.temperature = self.f.physicalExplorationUnitTemperature.value;
            cmd.physicalExplorationUnit.satO2 = self.f.physicalExplorationUnitSatO2.value;
            cmd.physicalExplorationUnit.actualWeight = self.f.physicalExplorationUnitActualWeight.value;
            cmd.physicalExplorationUnit.dryWeight = self.f.physicalExplorationUnitDryWeight.value;
            cmd.physicalExplorationUnit.observations = self.f.physicalExplorationUnitObservations.value;

            cmd.initialStudy = new PatientInitialStudyDto();
            cmd.initialStudy.id = self.model.initialStudy ? self.model.initialStudy.id : null;
            cmd.initialStudy.leukocytes = self.f.initialStudyLeukocytes.value;
            cmd.initialStudy.erythrocytes = self.f.initialStudyErythrocytes.value;
            cmd.initialStudy.hematrocitos = self.f.initialStudyHematrocitos.value;
            cmd.initialStudy.hemoglobin = self.f.initialStudyHemoglobin.value;
            cmd.initialStudy.volCorMiddle = self.f.initialStudyVolCorMiddle.value;
            cmd.initialStudy.hcm = self.f.initialStudyHcm.value;
            cmd.initialStudy.platelets = self.f.initialStudyPlatelets.value;
            cmd.initialStudy.volPlatMiddle = self.f.initialStudyVolPlatMiddle.value;
            cmd.initialStudy.neutrophils = self.f.initialStudyNeutrophils.value;
            cmd.initialStudy.lymphocytes = self.f.initialStudyLymphocytes.value;
            cmd.initialStudy.monocytes = self.f.initialStudyMonocytes.value;
            cmd.initialStudy.eosinophils = self.f.initialStudyEosinophils.value;
            cmd.initialStudy.basophils = self.f.initialStudyBasophils.value;
            cmd.initialStudy.urea = self.f.initialStudyUrea.value;
            cmd.initialStudy.creatinine = self.f.initialStudyCreatinine.value;
            cmd.initialStudy.glucose = self.f.initialStudyGlucose.value;
            cmd.initialStudy.uricAC = self.f.initialStudyUricAC.value;
            cmd.initialStudy.tfg = self.f.initialStudyTfg.value;
            cmd.initialStudy.ast = self.f.initialStudyAst.value;
            cmd.initialStudy.alt = self.f.initialStudyAlt.value;
            cmd.initialStudy.albumin = self.f.initialStudyAlbumin.value;
            cmd.initialStudy.tp = self.f.initialStudyTp.value;
            cmd.initialStudy.tpt = self.f.initialStudyTpt.value;
            cmd.initialStudy.inr = self.f.initialStudyInr.value;
            cmd.initialStudy.radiographyComments = self.f.initialStudyRadiographyComments.value;
            cmd.initialStudy.electrocardiogramComments = self.f.initialStudyElectrocardiogramComments.value;

            cmd.ginecoObstetrics = new PatientGinecoObstetricsDto();
            cmd.ginecoObstetrics.metodoPlanificacionFamiliarId = self.f.familiarPlanningMethod.value;
            cmd.ginecoObstetrics.menarca = self.f.menarca.value;
            cmd.ginecoObstetrics.ciclo = self.f.ciclo.value;
            cmd.ginecoObstetrics.alteracionMenstrual = self.f.menstrualIrregularity.value;

            if (self.f.lastPapilomaDate.value) {
                cmd.ginecoObstetrics.fechaUltimoPapiloma = self.dateTimeService.getDateToSaveServer(self.f.lastPapilomaDate.value);
            }

            cmd.ginecoObstetrics.resultado = self.f.result.value;
            cmd.ginecoObstetrics.gestas = self.f.pregnancies.value;
            cmd.ginecoObstetrics.partos = self.f.births.value;
            cmd.ginecoObstetrics.cesareas = self.f.cSections.value;
            cmd.ginecoObstetrics.abortos = self.f.abortions.value;

            self.lock();

            self.patientsService.updatePatient(cmd)
                .pipe(finalize(() => {
                    self.unlock();
                }))
                .subscribe(data => {
                    self.notify.success(self.l('SavedSuccessfully'), self.l('Success'));
                    self.return();
                });
        } else {
            const cmd = new PatientCreateCommand();

            cmd.idee = self.f.idee.value;
            cmd.patientTypeImss = self.f.patientTypeImss.value ? self.f.patientTypeImss.value.id : null;
            cmd.institution = self.f.institution.value;
            cmd.delegation = self.f.delegation.value;
            cmd.umf = self.f.umf.value;
            cmd.sex = self.f.sex.value;
            cmd.patientQuality = self.f.patientQuality.value;
            cmd.maritalStatus = self.f.maritalStatus.value;
            cmd.educationLevel = self.f.educationLevel.value;
            cmd.religion = self.f.religion.value;
            cmd.occupation = self.f.occupation.value;
            cmd.municipality = self.f.municipality.value;
            cmd.name = self.f.name.value;
            cmd.firstName = self.f.firstName.value;
            cmd.lastName = self.f.lastName.value;
            cmd.nss = self.f.nss.value;
            cmd.medicalAttache = self.f.medicalAttache.value;
            cmd.curp = self.f.curp.value;
            cmd.birthDate = self.f.birthDate.value;
            cmd.yearsStudy = self.f.yearsStudy.value;
            cmd.street = self.f.street.value;
            cmd.internalNumber = self.f.internalNumber.value;
            cmd.externalNumber = self.f.externalNumber.value;
            cmd.postalCode = self.f.postalCode.value;
            cmd.phone = self.f.phone.value;
            cmd.cellPhone = self.f.cellPhone.value;
            cmd.betweenStreets = self.f.betweenStreets.value;
            cmd.pointsReference = self.f.pointsReference.value;
            cmd.suburb = self.f.suburb.value;
            cmd.isActive = self.f.isActive.value;

            cmd.birthState = self.f.birthState.value;
            cmd.rfc = self.f.rfc.value;
            cmd.deathDate = self.f.deathDate.value;

            cmd.generalUnit = new PatientGeneralUnitDto();
            cmd.generalUnit.delegationImssRequest = self.f.delegationImssRequest.value;
            cmd.generalUnit.medicalCareUnit = self.f.medicalCareUnit.value;
            cmd.generalUnit.hospitalService = self.f.hospitalService.value;
            cmd.generalUnit.patientOrigin = self.f.patientOrigin.value;
            cmd.generalUnit.origin = self.f.origin.value;
            cmd.generalUnit.attentionType = self.f.attentionType.value;
            cmd.generalUnit.attentionPlace = self.f.attentionPlace.value;
            cmd.generalUnit.shift = self.f.shift.value;
            cmd.generalUnit.doctorOffice = self.f.doctorOffice.value;
            cmd.generalUnit.validUntil = self.f.validUntil.value;
            cmd.generalUnit.membershipAggregate = self.f.membershipAggregate.value;
            cmd.generalUnit.agreementType = self.f.agreementType.value;
            cmd.generalUnit.observations = self.f.observations.value;

            if (self.model.referenceUnitList && self.model.referenceUnitList.length === 1 && self.model.referenceUnitList[0].isChecked) {
                cmd.referenceUnit = self.model.referenceUnitList[0];
            }

            cmd.bloodType = self.f.bloodType.value;
            cmd.rhFactor = self.f.rhFactor.value;

            cmd.ginecoObstetrics = new PatientGinecoObstetricsDto();
            cmd.ginecoObstetrics.metodoPlanificacionFamiliarId = self.f.familiarPlanningMethod.value;
            cmd.ginecoObstetrics.menarca = self.f.menarca.value;
            cmd.ginecoObstetrics.ciclo = self.f.ciclo.value;
            cmd.ginecoObstetrics.alteracionMenstrual = self.f.menstrualIrregularity.value;

            if (self.f.lastPapilomaDate.value) {
                cmd.ginecoObstetrics.fechaUltimoPapiloma = self.dateTimeService.getDateToSaveServer(self.f.lastPapilomaDate.value);
            }

            cmd.ginecoObstetrics.resultado = self.f.result.value;
            cmd.ginecoObstetrics.gestas = self.f.pregnancies.value;
            cmd.ginecoObstetrics.partos = self.f.births.value;
            cmd.ginecoObstetrics.cesareas = self.f.cSections.value;
            cmd.ginecoObstetrics.abortos = self.f.abortions.value;

            self.lock();

            self.patientsService.createPatient(cmd)
                .pipe(finalize(() => {
                    self.unlock();
                }))
                .subscribe(data => {
                    self.notify.success(self.l('SavedSuccessfully'), self.l('Success'));
                    self.router.navigate(['/app/catalogs/patients/edit', data]);
                });
        }
    }

    prepareForm(): void {
        const self = this;

        self.form = self.formBuilder.group({
            idee: [null],
            patientTypeImss: [null],
            firstName: [null, [Validators.required, Validators.maxLength(50)]],
            lastName: [null, [Validators.maxLength(50)]],
            name: [null, [Validators.required, Validators.maxLength(50)]],
            curp: [null, [Validators.maxLength(18)]],
            sex: [null, [Validators.required]],
            birthDate: [null, [Validators.required]],
            institution: [null],
            delegation: [null],
            umf: [null],
            nss: [null, [Validators.maxLength(10)]],
            medicalAttache: [null, [Validators.maxLength(8)]],
            patientQuality: [null],
            maritalStatus: [null, [Validators.required]],
            educationLevel: [null],
            yearsStudy: [null],
            religion: [null],
            occupation: [null],
            street: [null, [Validators.maxLength(80)]],
            externalNumber: [null, [Validators.maxLength(6)]],
            internalNumber: [null, [Validators.maxLength(6)]],
            suburb: [null, [Validators.maxLength(40)]],
            postalCode: [null],
            phone: [null, [Validators.maxLength(20)]],
            cellPhone: [null, [Validators.maxLength(10)]],
            betweenStreets: [null, [Validators.maxLength(100)]],
            pointsReference: [null, [Validators.maxLength(100)]],
            country: [null],
            state: [null],
            municipality: [null],
            isActive: [true],

            birthCountry: [null],
            birthState: [null],
            rfc: [null, [Validators.maxLength(13)]],
            deathDate: [null],

            delegationImssRequest: [null],
            medicalCareUnit: [null],
            hospitalService: [null],
            patientOrigin: [null],
            origin: [null],
            attentionType: [null],
            attentionPlace: [null, [Validators.maxLength(50)]],
            shift: [null],
            doctorOffice: [null, [Validators.maxLength(50)]],
            validUntil: [null],
            membershipAggregate: [null, [Validators.maxLength(50)]],
            agreementType: [null],
            observations: [null, [Validators.maxLength(500)]],

            bloodType: [null],
            rhFactor: [null],
            etiology: [null],
            housingType: [null],
            isVHB: [false],
            isVHC: [false],
            isVIH: [false],
            albumina: [null],
            basalBloodGlucose: [null],
            hbA1c: [null],
            isDiabetes: [false],
            cholesterol: [null],
            cholesterolHDL: [null],
            cholesterolLDL: [null],
            triglycerides: [null],
            sanefroDate: [null],
            vaccinationSchedule: [null],
            vaccinationScheduleMissing: [null, [Validators.maxLength(50)]],
            foodPredominance: [null, [Validators.maxLength(1000)]],
            isSmoking: [false],
            smokingYears: [null],
            smokingMonths: [null],
            cigars: [null],
            isAlcoholism: [false],
            alcoholismLevel: [null],
            others: [null, [Validators.maxLength(1000)]],
            isBasicServices: [false],
            isWater: [false],
            isElectricity: [false],
            isSewerSystem: [false],
            ivsa: [null],
            sexualPartners: [null],
            fauna: [null],
            faunaType: [null],
            faunaQuantity: [null],
            filterTextFauna: [null],
            allergie: [null],
            allergieDate: [null],
            filterTextAllergie: [null],

            filterTextMedicalHistory: [null],

            isRespiratory: [false],
            respiratoryComments: [null, [Validators.maxLength(100)]],
            isCardiovascular: [false],
            cardiovascularComments: [null, [Validators.maxLength(100)]],
            isDigestive: [false],
            digestiveComments: [null, [Validators.maxLength(100)]],
            isGenitourinary: [false],
            genitourinaryComments: [null, [Validators.maxLength(100)]],
            isMusculoskeletal: [false],
            musculoskeletaComments: [null, [Validators.maxLength(100)]],
            isEndocrine: [false],
            endocrineComments: [null, [Validators.maxLength(100)]],
            isNeuropsychiatric: [false],
            neuropsychiatricComments: [null, [Validators.maxLength(100)]],
            hematopoietic: [null, [Validators.maxLength(100)]],
            skinIntegument: [null, [Validators.maxLength(100)]],

            physicalExplorationUnitImc: [null, [Validators.maxLength(20)]],
            physicalExplorationUnitTa: [null, [Validators.maxLength(10)]],
            physicalExplorationUnitHeartRate: [null],
            physicalExplorationUnitBreathingFrequency: [null],
            physicalExplorationUnitTemperature: [null, [Validators.maxLength(10)]],
            physicalExplorationUnitSatO2: [null],
            physicalExplorationUnitActualWeight: [null],
            physicalExplorationUnitDryWeight: [null],
            physicalExplorationUnitObservations: [null],

            initialStudyLeukocytes: [null, [Validators.maxLength(10)]],
            initialStudyErythrocytes: [null, [Validators.maxLength(10)]],
            initialStudyHematrocitos: [null, [Validators.maxLength(10)]],
            initialStudyHemoglobin: [null, [Validators.maxLength(10)]],
            initialStudyVolCorMiddle: [null, [Validators.maxLength(10)]],
            initialStudyHcm: [null, [Validators.maxLength(10)]],
            initialStudyPlatelets: [null, [Validators.maxLength(10)]],
            initialStudyVolPlatMiddle: [null, [Validators.maxLength(10)]],
            initialStudyNeutrophils: [null, [Validators.maxLength(10)]],
            initialStudyLymphocytes: [null, [Validators.maxLength(10)]],
            initialStudyMonocytes: [null, [Validators.maxLength(10)]],
            initialStudyEosinophils: [null, [Validators.maxLength(10)]],
            initialStudyBasophils: [null, [Validators.maxLength(10)]],
            initialStudyUrea: [null, [Validators.maxLength(10)]],
            initialStudyCreatinine: [null, [Validators.maxLength(10)]],
            initialStudyGlucose: [null, [Validators.maxLength(10)]],
            initialStudyUricAC: [null, [Validators.maxLength(10)]],
            initialStudyTfg: [null, [Validators.maxLength(10)]],
            initialStudyAst: [null, [Validators.maxLength(10)]],
            initialStudyAlt: [null, [Validators.maxLength(10)]],
            initialStudyAlbumin: [null, [Validators.maxLength(10)]],
            initialStudyTp: [null, [Validators.maxLength(10)]],
            initialStudyTpt: [null, [Validators.maxLength(10)]],
            initialStudyInr: [null, [Validators.maxLength(10)]],
            initialStudyRadiographyComments: [null],
            initialStudyElectrocardiogramComments: [null],

            familiarPlanningMethod: [null],
            menarca: [null],
            ciclo: [null],
            menstrualIrregularity: [null, [Validators.maxLength(100)]],
            lastPapilomaDate: [null],
            result: [null, [Validators.maxLength(200)]],
            pregnancies: [null],
            births: [null],
            cSections: [null],
            abortions: [null]
        });

        self.colsFauna = [
            { field: 'faunaDesc', header: self.l('Catalogos.Patients.Pathological.Faunas.Fauna.Col') },
            { field: 'faunaTypeDesc', header: self.l('Catalogos.Patients.Pathological.Faunas.FaunaType.Col') },
            { field: 'faunaQuantity', header: self.l('Catalogos.Patients.Pathological.Faunas.FaunaQuantity.Col') }
        ];

        self.colsAllergie = [
            { field: 'allergieDate', header: self.l('Catalogos.Patients.Pathological.Allergies.Date.Col') },
            { field: 'allergieDesc', header: self.l('Catalogos.Patients.Pathological.Allergies.Allergie.Col') }
        ];

        self.colsMedicalHistory = [
            { field: 'eventDate', header: self.l('Catalogos.Patients.MedicalHistory.Date.Col') },
            { field: 'eventTypeDesc', header: self.l('Catalogos.Patients.MedicalHistory.EventType.Col') },
            { field: 'catalogTypeDesc', header: self.l('Catalogos.Patients.MedicalHistory.CatalogType.Col') },
            { field: 'eventDesc', header: self.l('Catalogos.Patients.MedicalHistory.Event.Col') },
            { field: 'eventCode', header: self.l('Catalogos.Patients.MedicalHistory.EventCode.Col') },
            { field: 'age', header: self.l('Catalogos.Patients.MedicalHistory.Age.Col') },
            { field: 'isHereditaryDesc', header: self.l('Catalogos.Patients.MedicalHistory.Hereditary.Col') }
        ];

        self.f.idee.disable();

        // focus
        // setTimeout(() => this.inputFocus.nativeElement.focus(), 100);
    }

    blockFields(): void {
        const self = this;

        if (self.model.id && self.editFieldsPermission === false) {
            self.f.patientTypeImss.disable();
            self.f.name.disable();
            self.f.firstName.disable();
            self.f.lastName.disable();
            // self.f.curp.disable();
            self.f.sex.disable();
            self.f.birthDate.disable();
            // self.f.institution.disable();
            // self.f.delegation.disable();
            // self.f.umf.disable();
            self.f.nss.disable();
            self.f.medicalAttache.disable();
        }
    }

    changeInstitution(): void {
        const self = this;

        self.isIdeeButton = self.model.id && !self.f.idee.value && self.f.institution.value === self.institutionImssId;

        if (self.f.institution.value) {
            const ex = self.institutionsValidateList.find(m => m.id === self.f.institution.value);
            if (ex && ex.codigoInstitucion === self.codigoInstitucionIMSS) {
                self.esIMSS = true;
            } else {
                self.esIMSS = false;
            }
        } else {
            self.esIMSS = false;
        }
    }

    changePatientTypeImss(): void {
        const self = this;

        self.setEsDerechohabiente();
    }

    setEsDerechohabiente(): void {
        const self = this;

        console.log(self.f.patientTypeImss.value);

        if (self.f.patientTypeImss.value) {
            const ex = self.patientTypeImssList.find(m => m.value.id === parseInt(self.f.patientTypeImss.value.id, 10));

            console.log(ex);

            if (ex) {
                self.esDerechohabiente = ex.value.claveTipoPacienteIMSS === '1';
            }
        } else {
            self.esDerechohabiente = false;
        }
    }

    changeDelegation(): void {
        const self = this;

        if (self.f.delegation.value) {
            self.getUMFs();
        } else {
            self.umfList = [];
        }
    }

    getUMFs(): void {
        const self = this;

        self.lock();
        self.catalogosGeneralesService.getHospitalesForCombobox(self.f.delegation.value)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.umfList = data;
            });
    }

    changeDelegationRequest(): void {
        const self = this;

        if (self.f.delegationImssRequest.value) {
            self.getUMFsRequest();
        } else {
            self.umfRequestList = [];
            self.hospitalServiceList = [];

            self.f.medicalCareUnit.setValue(null);
            self.f.hospitalService.setValue(null);
        }
    }

    getUMFsRequest(): void {
        const self = this;

        self.lock();
        self.catalogosGeneralesService.getHospitalesForCombobox(self.f.delegationImssRequest.value)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.umfRequestList = data;
            });
    }

    getUMFRequestByClavePresupuestal(clavePresupuestal: string): void {
        const self = this;

        self.lock();
        self.catalogosGeneralesService.getHospitalByClavePresupuestal(clavePresupuestal)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {

                if (data) {
                    self.f.delegationImssRequest.setValue(data.delegacionId);
                    self.f.medicalCareUnit.setValue(data.id);

                    self.changeDelegationRequest();
                }
            });
    }

    changeUmfRequest(): void {
        const self = this;

        if (self.f.medicalCareUnit.value) {
            self.getHospitalServicesRequest();
        } else {
            self.hospitalServiceList = [];
            self.f.hospitalService.setValue(null);
        }
    }

    getHospitalServicesRequest(): void {
        const self = this;

        self.lock();
        self.catalogosGeneralesService.getServiciosHospitalesForCombobox(self.f.medicalCareUnit.value)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.hospitalServiceList = data;
            });
    }

    buscarIdee(): void {
        const self = this;

        const tp = self.f.patientTypeImss.value;

        console.log(tp);

        if (tp) {
            if (tp.claveTipoPacienteIMSS === '1' || tp.claveTipoPacienteIMSS === '3') {
                // El paciente es tipo 1="Derechohabiente" o 3="No derechohabiente".. se busca el IDEE en el IMSS
                self.doBuscarIdee();
            } else if (tp.claveTipoPacienteIMSS === '2') {
                // Si el paciente es de tipo 2="No encontrado", entonces se intenta crear en el IMSS
                self.doCrearPacienteEnIMSS();
            }
        } else {
            self.alertService.error(self.l('Catalogos.Patients.General1.PatientTypeImss.Error'));
        }
    }

    doCrearPacienteEnIMSS(): void {
        const self = this;

        const req = new BusquedaIMSSCrearPacienteCommand();
        req.curp = self.f.curp.value;
        req.origin = self.f.origin.value;
        req.agreementType = self.f.agreementType.value;
        req.name = self.f.name.value;
        req.firstName = self.f.firstName.value;
        req.lastName = self.f.lastName.value;

        if (self.f.sex.value) {
            const s = self.model.sexCombo.find(m => m.value.id === self.f.sex.value);
            if (s) {
                req.sexKey = s.value.claveSexo;
            }
        }

        req.birthDate = self.f.birthDate.value;
        req.street = self.f.street.value;
        req.phone = self.f.phone.value;
        req.suburb = self.f.suburb.value;
        req.observations = self.f.observations.value;
        req.hospitalId = self.f.umf.value;

        if (!req.hospitalId) {
            self.alertService.error(self.l('RequiredField', self.l('Catalogos.Patients.General1.UMF.Form')));
            return;
        }

        self.lock();

        self.integracionIMSSService.crearPacienteEnIMSS(req)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                if (data) {
                    self.f.idee.setValue(data);
                } else {
                    self.alertService.error(self.l('Catalogos.Patients.IDEE.NoEncontrado'));
                    return;
                }
            });
    }

    doBuscarIdee(): void {
        const self = this;

        const query = new BusquedaIMSSGetByIDEEQuery();

        query.tipoPaciente = self.f.patientTypeImss.value ? self.f.patientTypeImss.value.claveTipoPacienteIMSS : null;
        query.nombre = self.f.name.value;
        query.apellidoPaterno = self.f.firstName.value;
        query.apellidoMaterno = self.f.lastName.value;
        query.nss = self.f.nss.value;

        if (self.f.birthDate.value) {
            query.fechaNacimiento = self.dateTimeService.getDateToSaveServer(self.f.birthDate.value);
        }

        query.hospitalId = self.f.umf.value;

        if (!query.hospitalId) {
            self.alertService.error(self.l('RequiredField', self.l('Catalogos.Patients.General1.UMF.Form')));
            return;
        }

        self.lock();

        self.integracionIMSSService.getPacienteIMSSPorIDEE(query)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                if (data) {
                    self.setPatient(data);
                } else {
                    setTimeout(() => {
                        self.buscarUrgencias();
                    }, 500);
                }
            });
    }

    buscarUrgencias(): void {
        const self = this;

        const filter = new BusquedaUrgenciasGetListQuery();
        filter.nombre = self.f.name.value;
        filter.apellidoPaterno = self.f.firstName.value;
        filter.apellidoMaterno = self.f.lastName.value;
        filter.nss = self.f.nss.value;
        filter.tipoPaciente = self.f.patientTypeImss.value ? self.f.patientTypeImss.value.claveTipoPacienteIMSS : null;
        filter.agregadoMedico = self.f.medicalAttache.value;

        if (self.f.birthDate.value) {
            filter.fechaNacimiento = self.dateTimeService.getDateTimeToSaveServer(self.f.birthDate.value);
        }

        filter.hospitalId = self.f.umf.value;

        if (!filter.hospitalId) {
            self.alertService.error(self.l('RequiredField', self.l('Catalogos.Patients.General1.UMF.Form')));
            return;
        }

        self.lock();

        self.integracionIMSSService.getPacientesPorUrgenciasIMSS(filter)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {

                if (data.length <= 0) {
                    self.alertService.error(self.l('Busquedas.Pacientes.NoHayCoincidenciasError'));
                } else if (data.length === 1) {
                    self.setPatient(data[0]);
                } else {
                    self.mostrarGridUrgenciasModal(data);
                }
            });
    }

    mostrarGridUrgenciasModal(data: BusquedaIMSSResultDto[]): void {
        const self = this;
        const ref = self.dialogService.open(BusquedaPacientesUrgenciasGridComponent, {
            styleClass: 'd-sm d-md-70 d-lg-70 d-xl-70',
            header: self.l('Busquedas.Pacientes.Grid.Titulo'),
            showHeader: true,
            dismissableMask: false,
            // footer: 'DUMMY',
            data: {
                data: data
            }
        });

        ref.onClose.subscribe((paciente: BusquedaIMSSResultDto) => {
            if (paciente) {
                self.setPatient(paciente);
            }
        });
    }

    setPatient(res: BusquedaIMSSResultDto): void {
        const self = this;

        self.f.idee.setValue(res.idee);
        self.f.nss.setValue(res.nss);
        self.f.medicalAttache.setValue(res.agregadoMedico);
        self.f.name.setValue(res.nombre);
        self.f.firstName.setValue(res.apellidoPaterno);
        self.f.lastName.setValue(res.apellidoMaterno);
        self.f.curp.setValue(res.curp);

        if (res.numeroExterior.length > 0) {
            self.f.externalNumber.setValue(res.numeroExterior);
        }

        if (res.colonia.length > 0) {
            self.f.suburb.setValue(res.colonia);
        }

        if (res.codigoPostal.length > 0) {
            self.f.postalCode.setValue(res.codigoPostal);
        }

        if (res.numeroInterior.length > 0) {
            self.f.internalNumber.setValue(res.numeroInterior);
        }

        if (res.numeroTelefonico.length > 0) {
            self.f.phone.setValue(res.numeroTelefonico);
        }

        if (res.sexo && res.sexo.length > 0) {
            if (res.sexo.charAt(0) === 'M') {
                self.f.sex.setValue(self.maleId);
            } else if (res.sexo.charAt(0) === 'F') {
                self.f.sex.setValue(self.femaleId);
            }
        }

        const year = res.fechaNacimiento.get('year');

        if (year > 1763 && year <= self.dateTimeService.getCurrentDateTime().get('year')) {
            self.f.birthDate.setValue(self.dateTimeService.getDateToAssignInFormControl(res.fechaNacimiento));
        }
    }

    // Faunas

    onChangeFaunaType(): void {
        const self = this;

        if (!self.f.faunaType.value) {
            return;
        }

        self.lock();

        self.catalogosGeneralesService.getFaunaForCombobox(self.f.faunaType.value)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.faunaList = data;
            });
    }

    changeSex(): void {
        const self = this;
    }

    isFemale(): boolean {
        const self = this;

        if (self.f.sex.value) {
            const ex = self.model.sexCombo.find(m => m.value.id === self.f.sex.value);
            if (ex) {
                return ex.value.claveSexo === 'M';
            }
        }

        return false;
    }

    filterSearchFauna(event: any): void {
        const self = this;

        event.preventDefault();

        self.tableFauna.reset();
        self.queryFauna.pageNumber = 1;
    }

    getFaunaList(): void {
        const self = this;

        self.queryFauna.filter = self.f.filterTextFauna.value;
        self.queryFauna.patient = self.model.id;

        self.lock();

        self.patientsService.getPatientFaunaList(self.queryFauna)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.dataFauna = data.items;

                // Calculate paged table summary
                self.pagedTableSummaryFauna = self.getPagedTableSummay(
                    data.totalCount, self.queryFauna.pageNumber, self.queryFauna.pageSize);
            });
    }

    loadDataFauna(event: LazyLoadEvent) {
        const self = this;

        if (event.sortField) {
            self.queryFauna.sorting = event.sortField + ' ' + (event.sortOrder === 1 ? 'ASC' : 'DESC');
        } else {
            self.queryFauna.sorting = '';
        }

        self.queryFauna.pageNumber = 1 + (event.first / event.rows);
        self.queryFauna.pageSize = event.rows;

        if (!self.model.id) {
            return;
        }

        self.getFaunaList();
    }

    addFauna(): void {
        const self = this;

        if (!self.f.fauna.value) {
            return;
        }

        self.lock();

        const cmd = new PatientFaunaCreateCommand();
        cmd.patient = self.model.id;
        cmd.fauna = self.f.fauna.value;
        cmd.quantity = self.f.faunaQuantity.value;

        self.patientsService.createPatientFauna(cmd)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.notify.success(self.l('Catalogos.Patients.Pathological.Faunas.SuccessfulCreate'), self.l('Success'));
                self.getFaunaList();
            });
    }

    deleteFauna(rowData: PatientFaunaForListResponse): void {
        const self = this;

        self.alertService.confirmDelete(
            self.l('Catalogos.Patients.Pathological.Faunas.FaunaConfirmationDeleteMessage'),
            self.l('Confirmation'),
            function (resp) {

                if (!resp) {
                    return;
                }

                self.doDeleteFauna(rowData.id);
            }
        );
    }

    doDeleteFauna(patientFaunaId: number): void {
        const self = this;

        self.lock();

        self.patientsService.deletePatientFauna(new PatientFaunaDeleteCommand({ id: patientFaunaId }))
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.notify.success(self.l('Catalogos.Patients.Pathological.Faunas.SuccessfulDelete'), self.l('Success'));
                self.getFaunaList();
            });
    }

    // Allergies

    filterSearchAllergie(event: any): void {
        const self = this;

        event.preventDefault();

        self.tableAllergie.reset();
        self.queryAllergie.pageNumber = 1;
    }

    getAllergieList(): void {
        const self = this;

        self.queryAllergie.filter = self.f.filterTextAllergie.value;
        self.queryAllergie.patient = self.model.id;

        self.lock();

        self.patientsService.getPatientAllergieList(self.queryAllergie)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.dataAllergie = data.items;

                // Calculate paged table summary
                self.pagedTableSummaryAllergie = self.getPagedTableSummay(
                    data.totalCount, self.queryAllergie.pageNumber, self.queryAllergie.pageSize);
            });
    }

    loadDataAllergie(event: LazyLoadEvent) {
        const self = this;

        if (event.sortField) {
            self.queryAllergie.sorting = event.sortField + ' ' + (event.sortOrder === 1 ? 'ASC' : 'DESC');
        } else {
            self.queryAllergie.sorting = '';
        }

        self.queryAllergie.pageNumber = 1 + (event.first / event.rows);
        self.queryAllergie.pageSize = event.rows;

        if (!self.model.id) {
            return;
        }

        self.getAllergieList();
    }

    addAllergie(): void {
        const self = this;

        if (!(self.f.allergie.value && self.f.allergieDate.value)) {
            return;
        }

        self.lock();

        const cmd = new PatientAllergieCreateCommand();
        cmd.patient = self.model.id;
        cmd.allergie = self.f.allergie.value;
        cmd.allergieDate = self.f.allergieDate.value;

        self.patientsService.createPatientAllergie(cmd)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.notify.success(self.l('Catalogos.Patients.Pathological.Allergies.SuccessfulCreate'), self.l('Success'));
                self.getAllergieList();
            });
    }

    deleteAllergie(rowData: PatientAllergieForListResponse): void {
        const self = this;

        self.alertService.confirmDelete(
            self.l('Catalogos.Patients.Pathological.Allergies.AllergieConfirmationDeleteMessage'),
            self.l('Confirmation'),
            function (resp) {

                if (!resp) {
                    return;
                }

                self.doDeleteAllergie(rowData.id);
            }
        );
    }

    doDeleteAllergie(patientAllergieId: number): void {
        const self = this;

        self.lock();

        self.patientsService.deletePatientAllergie(new PatientAllergieDeleteCommand({ id: patientAllergieId }))
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.notify.success(self.l('Catalogos.Patients.Pathological.Allergies.SuccessfulDelete'), self.l('Success'));
                self.getAllergieList();
            });
    }

    // Medical History

    filterSearchMedicalHistory(event: any): void {
        const self = this;

        event.preventDefault();

        self.tableMedicalHistory.reset();
        self.queryMedicalHistory.pageNumber = 1;
    }

    getMedicalHistoryList(): void {
        const self = this;

        self.queryMedicalHistory.filter = self.f.filterTextMedicalHistory.value;
        self.queryMedicalHistory.patient = self.model.id;

        self.lock();

        self.patientsService.getPatientMedicalHistoryList(self.queryMedicalHistory)
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.dataMedicalHistory = data.items;

                // Calculate paged table summary
                self.pagedTableSummaryMedicalHistory = self.getPagedTableSummay(
                    data.totalCount, self.queryMedicalHistory.pageNumber, self.queryMedicalHistory.pageSize);
            });
    }

    loadDataMedicalHistory(event: LazyLoadEvent) {
        const self = this;

        if (event.sortField) {
            self.queryMedicalHistory.sorting = event.sortField + ' ' + (event.sortOrder === 1 ? 'ASC' : 'DESC');
        } else {
            self.queryMedicalHistory.sorting = '';
        }

        self.queryMedicalHistory.pageNumber = 1 + (event.first / event.rows);
        self.queryMedicalHistory.pageSize = event.rows;

        if (!self.model.id) {
            return;
        }

        self.getMedicalHistoryList();
    }

    addMedicalHistory(): void {
        const self = this;

        const ref = self.dialogService.open(EditPatientMedicalHistoryComponent, {
            styleClass: 'd-sm d-md-40 d-lg-40 d-xl-40',
            header: self.l('Catalogos.Patients.MedicalHistory.MedicalHistory'),
            showHeader: true,
            dismissableMask: false,
            data: {
                patient: self.model.id,
                birthDate: self.f.birthDate.value
            }
        });

        ref.onClose.subscribe(() => {
            self.getMedicalHistoryList();
        });
    }

    showMedicalHistory(rowData: PatientMedicalHistoryForListResponse): void {
        const self = this;

        const dialog = self.dialogService.open(EditPatientMedicalHistoryComponent, {
            styleClass: 'd-xl-40 d-lg-40 d-md-40 d-sm',
            showHeader: true,
            header: self.l('Catalogos.Patients.MedicalHistory.MedicalHistory'),
            dismissableMask: false,
            data: {
                id: rowData.id
            }
        });

        dialog.onClose.subscribe(() => {
        });
    }

    deleteMedicalHistory(rowData: PatientMedicalHistoryForListResponse): void {
        const self = this;

        self.alertService.confirmDelete(
            self.l('Catalogos.Patients.MedicalHistory.ConfirmationDeleteMessage'),
            self.l('Confirmation'),
            function (resp) {

                if (!resp) {
                    return;
                }

                self.doDeleteMedicalHistory(rowData.id);
            }
        );
    }

    doDeleteMedicalHistory(patientMedicalHistoryId: number): void {
        const self = this;

        self.lock();

        self.patientsService.deletePatientMedicalHistory(new PatientMedicalHistoryDeleteCommand({ id: patientMedicalHistoryId }))
            .pipe(finalize(() => {
                self.unlock();
            }))
            .subscribe(data => {
                self.notify.success(self.l('Catalogos.Patients.MedicalHistory.SuccessfulDelete'), self.l('Success'));
                self.getMedicalHistoryList();
            });
    }

    showChangeHistory(): void {
        const self = this;

        self.changeLogService.open('Pacientes', self.id);
    }

    lock(): void {
        const self = this;

        self.lockScreen = true;
    }

    unlock(): void {
        const self = this;

        self.lockScreen = false;
    }

    return(): void {
        if (this.esModal) {
            this.modalRef.close();
        } else {
            this.router.navigate(['/app/catalogs/patients']);
        }
    }
}
